export * from './internal-sever-error-page.component';
